import { useCallback, useState } from "react";
import Popup from "../../../components/Popup";
import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import Eatec from "../../../assets/img/SolutionsIcons/AgilysysEatec.svg";
import { Header } from "../../../components/Header";

const EatecFPage = () => {
    const [showVideo, setShowVideo] = useState<boolean>(false);
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    return (
      <div className="page splash eatecPage">
        <div className="page-title">
          <img src={Eatec} alt="" />
        </div>
        <Header />
        <div className="text-blocks">
          <div className="std-text">
            A modern, advanced inventory & procurement solution to help control
            the quality and consistency of your product purchases and inventory
            levels to ensure you have all of the ingredients for food & retail
            management success.{'\n\n'}
            
            The solution helps to maximize every dollar by
            supporting in-house production and cycle menu management with plate
            cost analysis and integrated procurement, reducing waste, spoilage,
            theft and overstock.{'\n\n'}

            With robust recipe and nutritional information
            management and a built-in banquet catering module, Eatec inventory &
            procurement management is a single flexible solution for
            multi-location food and item controls.{'\n\n'}
            
            The result is lower food
            costs, fewer out of stock occurrences and streamlined inventory
            processes.
          </div>
        </div>
        <div
          className="play-video"
          onClick={() => {
            _logEvent("click", "Solutions - Eatec", "Play Video");
            addFlow("Play Video");
            setShowVideo(true);
          }}
        >
          <PlayTriangle />
          Play Video
        </div>
        <img
          className="img-1"
          src={
            "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/eatec1.png"
          }
          alt=""
        />
        <img
          className="img-2"
          src={
            "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/eatec2.png"
          }
          alt=""
        />
        <Popup
          showPopup={showVideo}
          setShowPopup={() => setShowVideo(false)}
          disableOffClick={true}
        >
          <>
            {showVideo && (
              <video
                autoPlay
                controls
                src={
                  "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/videos/InteractiveEatec.mp4"
                }
              />
            )}
          </>
        </Popup>
      </div>
    );
}

export default EatecFPage;